import { render } from "./SelectGroup.vue?vue&type=template&id=d2acb09c&scoped=true"
const script = {}

import "./SelectGroup.vue?vue&type=style&index=0&id=d2acb09c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2acb09c"]])

export default __exports__